export default __webpack_public_path__ + "static/media/nat_m.e0b2d4c6.jpg";